import { render, staticRenderFns } from "./personal-contact.vue?vue&type=template&id=43c5d2ec&"
import script from "./personal-contact.vue?vue&type=script&lang=js&"
export * from "./personal-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports